<template>
    <DataTable
            v-redirect-if-no-permission:CAR_COLORS
            :url="api.ACTIONS.COLORS"
            :fieldsHiddenMain='["deleted_at","created_at","updated_at"]'
            :fieldsHiddenAdd='["created_at","deleted_at","updated_at","id"]'
            :fieldsHiddenEdit='["created_at","deleted_at","updated_at","id"]'
            :fieldsExtraAdd="fieldsExtraAdd"
            :titles="titles"
            :formatter="formatter"
            :add-rules="addRules"
            :title='$t("catalogPage.pageTitleColors")'/>
</template>

<script>
    import DataTable from "@/components/monaco/DataTable";
    import { formatCompanyTime } from "@/util/companyTime";
    import api from "@/constants/api.js";

    export default {
        name: "Colors",
        title() {
            return this.$t("catalogPage.pageTitleColors");
        },
        components: {DataTable},
        data() {
            return {
                api,
                defaultItem: {
                    name_en: "",
                    name_ar: "",
                },
            };
        },
        computed: {
            titles() {
                return {
                    "id": "#",
                    "name_en": this.$t("catalogPage.colNameEn"),
                    "name_ar": this.$t("catalogPage.colNameAr"),
                    "created_at": this.$t("catalogPage.colDateCreated"),
                    "updated_at": this.$t("catalogPage.colDateUpdated")
                }
            },
            fieldsExtraAdd() {
                return {
                    name_en: "v-text-field",
                    name_ar: "v-text-field",
                };
            },
            addRules() {
                return {
                    name_en: [val => !!val || this.$t("catalogPage.ruleRequired")],
                    name_ar: [val => !!val || this.$t("catalogPage.ruleRequired")],
                };
            },
            formatter() {
                const vm = this;
                return {
                    created_at(value) {
                        if (!value) return vm.$t("catalogPage.notAvailable");
                        return formatCompanyTime(value, "YYYY-MM-DD");
                    },
                    updated_at(value) {
                        if (!value) return vm.$t("catalogPage.notAvailable");
                        return formatCompanyTime(value, "YYYY-MM-DD");
                    },
                };
            },
        }
    }
</script>

<style scoped>

</style>
